import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Stack, Button, Box } from "@mui/material";
import { LEVEL_STYLES } from "../../../utils/uistyles";

const LevelRatesDialog = ({ trigger }) => {
	const [open, setOpen] = useState(false);

	const rates = [
		{ key: "l1", label: "Level 1", value: "$0.50" },
		{ key: "l2", label: "Level 2", value: "$0.30" },
		{ key: "l3", label: "Level 3", value: "$0.20" },
	];

	return (
		<>
			{/* Trigger */}
			<span onClick={() => setOpen(true)} style={{ cursor: "pointer" }}>
				{trigger}
			</span>

			{/* Dialog */}
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				PaperProps={{
					sx: {
						width: "360px !important",
						maxWidth: "360px !important",
					},
				}}
			>
				<DialogTitle
					sx={{
						fontSize: "1.7rem !important",
						color: "#1D54A2",
					}}
				>
					Level Rates
				</DialogTitle>

				<DialogContent
					sx={{
						p: 3,
					}}
				>
					<Typography
						variant="caption"
						sx={{
							fontSize: 11,
							color: "#666",
							display: "block",
							mb: 2,
						}}
					>
						Level Rates are Below:
					</Typography>

					<Stack spacing={1.5}>
						{rates.map((item) => {
							const s = LEVEL_STYLES[item.key];

							return (
								<Box
									key={item.key}
									sx={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										p: "10px 14px",
										borderRadius: "10px",
										backgroundColor: s.card.background,
										border: `1px solid ${s.line}`,
										gap: 2,
										boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
									}}
								>
									<Typography
										sx={{
											fontSize: 13,
											fontWeight: 600,
											color: s.name,
										}}
									>
										{item.label}
									</Typography>

									<Typography
										sx={{
											fontSize: 13,
											fontWeight: 700,
											color: s.value,
										}}
									>
										{item.value}
									</Typography>
								</Box>
							);
						})}
					</Stack>

					{/* Close button */}
					<Box sx={{ mt: 3, textAlign: "right" }}>
						<Button
							onClick={() => setOpen(false)}
							variant="contained"
							sx={{
								backgroundColor: "#1D54A2",
								textTransform: "none",
								borderRadius: "8px",
								px: 3,
								py: 0.8,
								fontSize: 13,
								fontWeight: 600,
								"&:hover": {
									backgroundColor: "#174a91",
								},
							}}
						>
							Close
						</Button>
					</Box>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default LevelRatesDialog;
